// Product-page upsells belong to one form. Let Prestige submit its normal FormData,
// including bundled sections, properties and selling plans; never intercept unrelated cart requests.
(() => {
  if (window.dfProductUpsellBound) return;
  window.dfProductUpsellBound = true;

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
  }).format(cents / 100);

  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const container = target.closest('.product-upsell');
    if (!container) return;
    if (!target.matches('select[data-upsell-variant-select]')) return;

    const item = target.closest('.product-upsell__item');
    const option = target.selectedOptions[0];
    if (!item || !option) return;
    const checkbox = item.querySelector('[data-upsell-checkbox]');
    if (checkbox) checkbox.dataset.variantId = target.value;
    const price = Number(option.dataset.price);
    const compare = Number(option.dataset.comparePrice);
    const box = item.querySelector('[data-upsell-price]');
    if (box && Number.isFinite(price)) {
      box.replaceChildren();
      const label = (className, text) => {
        const span = document.createElement('span');
        span.className = className;
        span.textContent = text;
        box.append(span);
      };
      if (compare > price) {
        label('product-upsell__price-compare', '+' + money(compare));
        label('product-upsell__price-sale', '+' + money(price));
        label('product-upsell__badge', '-' + Math.round((compare - price) / compare * 100) + '%');
      } else {
        label('product-upsell__price-regular', '+' + money(price));
      }
    }
    const image = item.querySelector('.product-upsell__image img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
  });

  function syncRestoredSelections() {
    document.querySelectorAll('.product-upsell select[data-upsell-variant-select]').forEach(select => {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  // CSS follows :checked directly, including Firefox-restored state. Re-render only
  // the selected variant's price/image; never change the customer's selection.
  window.addEventListener('pageshow', syncRestoredSelections);
  document.addEventListener('product:rerender', () => requestAnimationFrame(syncRestoredSelections), true);
  document.addEventListener('shopify:section:load', syncRestoredSelections);
  syncRestoredSelections();

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.target.closest('a, button, select, option, input, label')) return;
    const item = event.target.closest('.product-upsell__item');
    const checkbox = item?.querySelector('[data-upsell-checkbox]');
    if (!checkbox || checkbox.disabled) return;
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // A Shopify form has an input named id, which shadows the form.id property.
    const formId = form.getAttribute('id');
    if (!formId) return;
    const container = document.querySelector(`.product-upsell[data-product-form="${CSS.escape(formId)}"]`);
    const data = event.formData;
    if (!container || !data.get('id') || data.has('items[0][id]')) return;
    const selected = [...container.querySelectorAll('[data-upsell-checkbox]:checked:not(:disabled)')]
      .map(checkbox => ({ checkbox, id: checkbox.closest('.product-upsell__item')
        ?.querySelector('select[data-upsell-variant-select]')?.value || checkbox.dataset.variantId }))
      .filter(item => /^\d+$/.test(item.id || ''));
    if (!selected.length) return;

    // Convert only line-item fields. Keep form metadata (sections, sections_url,
    // on_success, attributes…) intact. File properties remain File objects.
    for (const [key, value] of [...data.entries()]) {
      let itemKey;
      if (['id', 'quantity', 'selling_plan'].includes(key)) itemKey = `items[0][${key}]`;
      else if (key.startsWith('properties[')) itemKey = 'items[0][properties]' + key.slice('properties'.length);
      if (!itemKey) continue;
      data.delete(key);
      data.append(itemKey, value);
    }
    if (!data.has('items[0][quantity]')) data.set('items[0][quantity]', '1');
    selected.forEach(({ checkbox, id }, index) => {
      const prefix = `items[${index + 1}]`;
      data.set(`${prefix}[id]`, id);
      data.set(`${prefix}[quantity]`, '1');
      data.set(`${prefix}[properties][_upsell]`, 'true');
      data.set(`${prefix}[properties][_upsell_source]`, container.dataset.productHandle || '');
      data.set(`${prefix}[properties][_upsell_handle]`, checkbox.dataset.upsellHandle || '');
    });
  }, true);
})();
